export default __webpack_public_path__ + "static/media/pemetaan-1.2b12e35c.jpg";